import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    restoreTranslation: translate({ id: 'global.restore' }),
  }))

  return api
}
